<div #mainDiv_ll_loanmgmt_bbc_switch>

  <!-- Horizontal line: 20px below the tab row -->
  <div *ngIf="bundle.showTab"
         [style.top.px]="-4"
          [style.left.px]="-3"
          [style.width.px]="bundle.remainingW - 20"
       style="position: absolute; z-index: 99; border-bottom: 2px solid rgb(198, 195, 195); box-sizing: border-box;">
  </div>

  <!-- horzTabs_ll_companys_sp  TABS ACROSS THE TOP-->
  <div *ngIf="bundle.showTab"
       [style.top.px]="0"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="30"
       style="position:absolute; z-index:100; box-sizing:border-box;">

    <div *ngFor="let item of bundle.horzTabs; let i = index"
         style="float:left; white-space:nowrap; cursor:pointer;"
         (click)="selectTab(item.lbl)">

      <!-- Active tab -->
      <div *ngIf="item.lbl === bundle.activeHorzTab"
           class="wordBtn14_selected"
           style="float:left; padding:10px; box-sizing:border-box;">
        {{ item.lbl }}
      </div>

      <!-- Inactive tab -->
      <div *ngIf="item.lbl !== bundle.activeHorzTab"
           class="wordBtn14"
           style="float:left; padding:10px; box-sizing:border-box;">
        {{ item.lbl }}
      </div>

    </div>

    <div class="txtNorm14"
         style="float: left; padding-top: 10px; padding-left: 30px; box-sizing: border-box;">
      AR Avaliability:
    </div>

    <div *ngFor="let item of bundle.collateral; let i = index"
         style="float:left; white-space:nowrap; cursor:pointer;"
         (click)="selectTab(item.lbl)">

      <!-- Active tab -->
      <div *ngIf="item.lbl === bundle.activeHorzTab"
           class="wordBtn14_selected"
           style="float:left; padding:10px; box-sizing:border-box;">
        {{ item.lbl }}
      </div>

      <!-- Inactive tab -->
      <div *ngIf="item.lbl !== bundle.activeHorzTab"
           class="wordBtn14"
           style="float:left; padding:10px; box-sizing:border-box;">
        {{ item.lbl }}
      </div>

    </div>

  </div>

  <!-- ll-contact-info-->
  <div *ngIf="bundle.showRemaining"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">

    <!--<ll-loanmgmt-loanrecord *ngIf="bundle.activeHorzTab == 'Enter BBC Data'" id="ll-loanmgmt-bbc-switch"></ll-loanmgmt-loanrecord>-->
    <ll-loanmgmt-bbc-display *ngIf="bundle.activeHorzTab == 'Enter BBC Data'" id="ll-loanmgmt-bbc-switch"></ll-loanmgmt-bbc-display>

    <ll-loanmgmt-bbc *ngIf="bundle.LOANMODELBBCRECORDID > 0 && bundle.activeHorzTab == 'View-Print BBC PDF'" id="bbc"></ll-loanmgmt-bbc>

    <div *ngIf="bundle.LOANMODELBBCRECORDID === 0 && bundle.activeHorzTab == 'View-Print BBC PDF'">

      <div class="txtNorm14" style="float: left; padding-top: 30px; padding-left: 30px; box-sizing: border-box;">
        BBC Needs to be Saved, Signed, or Accepted before a PDF can be generated.
      </div>


    </div>


    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Locations'" id="ll_loanmgmt_bbc_switch"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Classes'" id="ll_loanmgmt_bbc_switch"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Payers'" id="ll_loanmgmt_bbc_switch"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Unposted'" id="ll_loanmgmt_bbc_switch"></ll-admin-generic-dg>
    <ll-admin-generic-dg *ngIf="bundle.activeHorzTab == 'Location-Payers'" id="ll_loanmgmt_bbc_switch"></ll-admin-generic-dg>
  </div>




</div>
